module.exports = __webpack_public_path__ + "static/media/Eric Poole Headshot_1621251053112.ead6e014.png";